import { getI18n } from "react-i18next";
import { OfferFrequency } from "Types/api/OfferFrequency";
import { VehicleState } from "Types/state";

export const getPaymentFrequencyText = (frequency: OfferFrequency) => {
    const i18n = getI18n();
    switch (frequency) {
        case "biweekly":
            return i18n.t("CalculatedPayment.paymentFrequency.bi-weekly");
        case "weekly":
            return i18n.t("CalculatedPayment.paymentFrequency.weekly");
        default:
            return i18n.t("CalculatedPayment.paymentFrequency.month");
    }
};

export const requestStarted = (state: VehicleState, isUpdating = true) => {
    return {
        isUpdating,
        requests: (state?.requests ?? 0) + 1,
    };
};

export const requestFinished = (state: VehicleState) => {
    return {
        isUpdating: (state?.requests ?? 0) > 1,
        requests: (state?.requests ?? 0) >= 1 ? state?.requests - 1 : 0,
    };
};
